export default __webpack_public_path__ + "static/media/hht2_ep10_timeline_q04_b.e8fe562f.png";